import type { CountLabel } from "./format-limit.types";

import { defineCopy } from "../intl";

import { SHOWCASE_FEATURE_LABELS_COPY_EN_US, SHOWCASE_COUNT_LABELS_COPY_EN_US, SHOWCASE_LIMIT_COPY_EN_US } from "./en-us/showcase-features.copy";
import { SHOWCASE_FEATURE_LABELS_COPY_ES_ES, SHOWCASE_COUNT_LABELS_COPY_ES_ES, SHOWCASE_LIMIT_COPY_ES_ES } from "./es-es/showcase-features.copy";

/**
 * Rótulo de cada feature da vitrine (`SHOWCASE_FEATURES`), por chave do
 * catálogo. A copy é de marketing; o número vem dos entitlements do plano. O
 * catálogo da API usa rótulo de admin ("Convites pendentes"), que não serve
 * para vender.
 */
export const SHOWCASE_FEATURE_LABELS_COPY_PT_BR = {
  "content.tasks": "Tarefas",
  "content.scripts": "Roteiros",
  "calendar.events": "Eventos de calendário",
  "notes.items": "Notas",

  "campaigns.jobs": "Campanhas",
  "calculator.calculations": "Cálculos de publi",
  "calculator.pdf": "PDFs exportados",
  "calculator.whitelabel": "PDF sem marca Tãmi",

  "finance.entries": "Histórico financeiro",
  "social.profiles": "Redes conectadas",
  "social.syncInterval": "Coleta de métricas",
  "social.history": "Histórico de engajamento",

  "assistant.whatsapp": "Assistente do WhatsApp",
  "assistant.messages": "Mensagens na assistente do WhatsApp",
  "assistant.audioMinutes": "Áudios transcritos no WhatsApp",
  "assistant.proactive": "Notificações pelo WhatsApp",

  "team.members": "Membros da equipe",
  "storage.total": "Armazenamento",
  "storage.perFile": "Tamanho por arquivo",
} as const;

/** Rótulo da coisa contada, para as features de `SHOWCASE_FEATURES` que usam `countLabel`. */
export const SHOWCASE_COUNT_LABELS_COPY_PT_BR = {
  audioMinutes: { one: "min", other: "min" },
  teamMembers: { one: "membro", other: "membros" },
} satisfies Record<string, CountLabel>;

/** Texto de `formatShowcaseLimit`. */
export const SHOWCASE_LIMIT_COPY_PT_BR = {
  /** Feature sem entrada no mapa de entitlements do plano. */
  missing: "—",
  /** "1 dia" ou "X dias", prazo do recurso dentro da janela de teste. */
  days: (limit: number) => (limit === 1 ? "1 dia" : `${limit} dias`),
  /** Valor formatado + prazo: "ilimitado nos 30 dias". */
  withDeadline: (value: string, days: string) => `${value} nos ${days}`,
} as const;

export const SHOWCASE_FEATURE_LABELS_COPY = defineCopy(SHOWCASE_FEATURE_LABELS_COPY_PT_BR, {
  "en-US": SHOWCASE_FEATURE_LABELS_COPY_EN_US,
  "es-ES": SHOWCASE_FEATURE_LABELS_COPY_ES_ES,
});

export const SHOWCASE_COUNT_LABELS_COPY = defineCopy(SHOWCASE_COUNT_LABELS_COPY_PT_BR, {
  "en-US": SHOWCASE_COUNT_LABELS_COPY_EN_US,
  "es-ES": SHOWCASE_COUNT_LABELS_COPY_ES_ES,
});

export const SHOWCASE_LIMIT_COPY = defineCopy(SHOWCASE_LIMIT_COPY_PT_BR, {
  "en-US": SHOWCASE_LIMIT_COPY_EN_US,
  "es-ES": SHOWCASE_LIMIT_COPY_ES_ES,
});
